import { AuthProvider as OidcAuthProvider } from "react-oidc-context";
import { oidcConfig } from "../utils/oidcConfig";
import oidcJson from "../../mockData/idToken.json";
import { onSigninCallback } from "../utils/oidcUtil";

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    if (import.meta.env.MODE === "development") {
        // Comment out the lines below to run the app in development mode without mocking the API
        const storageKey = `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`;
        globalThis.localStorage.setItem(storageKey, JSON.stringify(oidcJson));
    }

    return (
        <OidcAuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
            {children}
        </OidcAuthProvider>
    );
};

export { AuthProvider };
